import { render, staticRenderFns } from "./RuleActions.vue?vue&type=template&id=ce4ecb96&scoped=true&"
import script from "./RuleActions.vue?vue&type=script&lang=ts&"
export * from "./RuleActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4ecb96",
  null
  
)

export default component.exports